import { render, staticRenderFns } from "./card_blog.vue?vue&type=template&id=7141868e&scoped=true&"
import script from "./card_blog.vue?vue&type=script&lang=js&"
export * from "./card_blog.vue?vue&type=script&lang=js&"
import style0 from "./card_blog.vue?vue&type=style&index=0&id=7141868e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7141868e",
  null
  
)

export default component.exports